import { createFileRoute } from '@tanstack/react-router';

import { ReferralScreen } from '@/screens/onboarding/ReferralScreen';

export const Route = createFileRoute('/_onboarding/onboarding/referral-code')({
  component: ReferralScreen,
});
